import React, { useState, useEffect, useRef } from "react";
import ApiService from "../../utils/Api";
import io from "socket.io-client";
import { GET_TRIPS, GET_USER } from "../../utils/Endpoint";
import { toast } from "react-toastify";
import moment from "moment";
import ReactStars from "react-stars";
import { render } from "react-dom";
import { Router, useNavigate } from "react-router-dom";
import PaymentComponent from "../profile/walletRecharge/Payment";
import useGMTTime from "../Time/time";
import PaymentCardComponent from "../payWithCard/paymentWithcard";
import { useTimer } from "react-timer-hook";

const SOCKET_SERVER_URL = "https://socket.Grepix.ca"; // Your server URL

function MyTimer({ expiryTimestamp }) {
  const {
    seconds,
    minutes,
    hours,
    days,
    isRunning,
    start,
    pause,
    resume,
    restart,
  } = useTimer({
    expiryTimestamp,
    autoStart: true,
    onExpire: () => setExpired(true),
  });
  const [expired, setExpired] = useState(false);

  return (
    <div style={{ textAlign: "center" }}>
      <div style={{ fontSize: "25px" }}>
        {!expired ? (
          <>
            <span>{minutes}</span>:<span>{seconds}</span>
          </>
        ) : (
          <div style={{ fontSize: "15px" }}>
            <span>Timer expired</span>
          </div>
        )}
      </div>
      <p>No cancellation fees will be charged before the timer expires.</p>
    </div>
  );
}
const TripProcessPage = (props) => {
  const navigate = useNavigate();

  const [connected, setConnected] = useState(false);
  const [loggedUser, setLoggedUser] = useState({});
  const [customOffer, setCustomizeOffer] = useState(false);
  const [offers, setOffers] = useState([]);
  const [offerTrip, setOfferTrip] = useState({});
  const socketRef = useRef(null);
  const [toggle, setToggle] = useState(false);
  const [trip_Id, setTrip_Id] = useState();
  const [driver_Id, setDriver_Id] = useState();
  const [feebackState, setfeebackState] = useState(true);
  const [response, setResponse] = useState([]);
  const [ride, setride] = useState(false);
  const [reason, setReason] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [iosToken, setIosToken] = useState("");
  const [andrToken, setAndrToken] = useState("");
  const [bookingtable, setbookingtable] = useState([]);
  const [thank, setThank] = useState(false);
  const [cardPay, setCardPay] = useState(false);
  const [payAmount, setPayAmount] = useState();
  const [rating, setNewRating] = useState();
  const [previousResponse, setPreviousResponse] = useState([]);
  const [city_pay_options, setCity_Pay_Options] = useState();

  const [feedback, setFeedback] = useState("");
  const [cancelPopup, setcancelPopup] = useState(false);
  const [driverCancel, setDriverCancel] = useState(true);
  const [tripShow, setTripShow] = useState(true);
  const [tripcancel, settripcancel] = useState(false);

  const tripaccept = sessionStorage.getItem("tripaccept");
  const city_id = sessionStorage.getItem("city_id");
  const storage_trip_id = localStorage.getItem("storagetripid");


   const [card, setCard] = useState(false);

 
const handleCloseCard = () => {
  setCard(false);
};

  const [cardEndTripPay, setcardEndTripPay] = useState(false);

  useEffect(() => {
    setCity_Pay_Options([
      { id: 1, name: "Card" },
      { id: 2, name: "Wallet" },
      { id: 3, name: "Cash" },

   ])
 
  },[])

  useEffect(() => {
    sessionStorage.setItem("driver_Id", driver_Id);
  }, [driver_Id]);

  const handleCancelClick = () => {
    setcancelPopup(true);
  };

  const [tripData, setTripData] = useState();


  const handlePayCardOption = (trip) => {
    setTripData(trip)
    setTrip_Id(trip.trip_id);
    if (trip.trip_id) {
      sessionStorage.setItem("tripaccept", JSON.stringify(csvData[0]));
    }
    setCard(true);
  };

  const handlePayCardOptionClose = () => {
    setcardEndTripPay(false);
  };

  const [cancelStatus, setCancelStatus] = useState(false);
  const [cancelFee, setcancelFee] = useState(false);

  const handleSubmit = () => {
    setCancelStatus(true);
    setcancelFee(true);
    handleClosepop();
  };

  const handleInputChange = (event) => {
    setFeedback(event.target.value);
  };

  const ratingChanged = (newRating) => {
    setNewRating(newRating);
  };

  const CardPayHandle = () => {
    setCardPay(true);
  };

  const getStarBackgroundColor = (rating) => {
    if (rating >= 4) return "#4CAF50"; // Green for excellent ratings
    if (rating >= 3) return "#FFC107"; // Yellow for average ratings
    return "#FF5722"; // Red for low ratings
  };


  const statusValues = {
    request: "Request",
    assigned: "Partner Assigned",
    accept: "Partner Accepted",
    arrive: "Partner Arrived",
    begin: "Begin",
    completed: "Completed",
    cancel: "Cancelled",
    p_cancel_pickup: "Partner Cancel at Pickup Location",
    p_cancel_drop: "Partner Cancel at Drop Location",
    expired: "Expired",
    paid_cancel: "Cancelled",
  };
  useEffect(() => {
    const intervalId = setInterval(() => {
      getTripHistory();
      handleTripComplete();
    }, 10000); // 20 seconds in milliseconds
    // Cleanup function to clear the interval when the component is unmounted
    return () => clearInterval(intervalId);
  }, []);
  const csvstatus = { Request: "request" };

  const handleButtonClick = () => {
    setShowPopup(!showPopup);
    setShowNotification(true);
    setTimeout(() => {
      setShowNotification(false);
    }, 3000); // Hide notification after 3 seconds
  };

  const [decline_trip, setdecline_trip] = useState(false);

  const tid = localStorage.getItem("tripid");

  useEffect(() => {
    setTrip_Id(tid);
  }, [tid]);

  const [offerAmt, setOfferAmt] = useState();
  const [otp, setotp] = useState("");
  const api_key = sessionStorage?.getItem("key");
  const timer = sessionStorage.getItem("timer");

  const [expiryTimestamp, setExpiryTimestamp] = useState(null);

  const startTimer = () => {
    const time = new Date();
    time.setSeconds(time.getSeconds() + 60 * timer); // Set the timer for 2 minutes
    setExpiryTimestamp(time);
  };

  const userId = sessionStorage.getItem("userid");
  const uFname = sessionStorage.getItem("fname");
  const uLname = sessionStorage.getItem("lname");
  const tripPayAmountMin = sessionStorage.getItem("tripPayAmountMin");
  const cityd = localStorage.getItem("cityInfo");
  let cityInfo;

  if (cityd) {
    try {
      cityInfo = JSON.parse(cityd);
    } catch (error) {
      console.error("Invalid JSON:", error);
    }
  } else {
    console.error("No city data found");
  }
  var d = new Date();
  var formattedTime = moment.utc(d).format("YYYY-MM-DD HH:mm:ss");
  const trip_pay_mode = sessionStorage.getItem("trip_pay_mode");
  // const { formattedTime } = useGMTTime(cityInfo);

  useEffect(() => {
    setLoggedUser({ userId, uFname, uLname });
  }, [userId]);

  const handleCloseTripDetail = () => {
    sessionStorage.removeItem("ride");
    localStorage.removeItem("tripid");
    localStorage.removeItem("storagetripid");
    settripcancel(false);
    setTripShow(false);
  };

  const handlePayClick = () => {
    setShowPopup(!showPopup);
  };

  const declineNotificationApi = async () => {
    if (reason?.length < 10) {
      toast.dismiss()
      toast.error("Reason should be minimum 10 words. Please fill it out.");
      return
    }
    const params = {
      trip_id: csvData[0].trip_id,
      trip_status: "cancel",
      trip_pay_status: "Paid",
      trip_reason: reason,
      driver_id: csvData[0].driver_Id,
      is_cancelled: 1,
      is_return_details: 1,
      can_fee_by: "r",
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/tripapi/updatetrip?api_key=${api_key}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(params),
        }
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const result = await response.json();

      localStorage.removeItem("tripid");

      setCancelStatus(true);
      // setcancelFee(true);
      // handleClosepop();
      // sessionStorage.removeItem("ride");
      // setride(false);
      // setcardEndTripPay(false);
      // setOffers([]);
      // setdecline_trip(false);
      // setcancelFee(false);
      // setReason("");
      // setDriverCancel(true);
      // settripcancel(true);
      // closePayHandle(false);
      // handleClosepop(false);

      sessionStorage.setItem("payStatus", true);
      setCancelStatus(true);
      // setcancelFee(true);
      handleClosepop();
      sessionStorage.removeItem("ride");
      setride(false);
      // setcardEndTripPay(false);
      setOffers([]);
      // setdecline_trip(false);
      // setcancelFee(false);
      setReason("");
      setDriverCancel(true);
      settripcancel(true);
      // closePayHandle(false);
      // handleClosepop(false);

      const Params = {
        trip_id: csvData[0].trip_id,
        trip_status: "cancel",
        sound: "driver_cancel.caf",
        android:
          csvData[0].Driver.d_device_type == "Android"
            ? csvData[0].Driver.d_device_token
            : "",
        ios:
          csvData[0].Driver.d_device_type.toLowerCase() == "ios"
            ? csvData[0].Driver.d_device_token
            : "",
        to: "driver",
        message: "Rider has cancelled the Ride.",
      };
      try {
        const response = await fetch(
          `https://apis.yellowtaxi.in/api/v1/push2/driver-android-ios-push-notification?api_key=${api_key}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(Params),
          }
        );

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const result = await response.json();
        setdecline_trip(false);
        // window.location.reload();
      } catch (error) {
        console.error("Error sending notification:", error);
      }
      setdecline_trip(false);
      // console.log("Notification sent:", result);
    } catch (error) {
      console.error("Error sending notification:", error);
    }
  };
  const userid = sessionStorage.getItem("userid");

  useEffect(() => {
    if (offerTrip.offeramt != null) setOfferAmt(offerTrip.offeramt);
  }, [offerTrip.offeramt]);

  const handleClose = () => {
    sessionStorage.removeItem("ride");
    setcancelPopup(false);
    setThank(false);
    setride(false);
    localStorage.removeItem("tripid");
    setcardEndTripPay(false);
    setOffers([]);
    setdecline_trip(false);
    setcancelFee(false);
    setReason("");
    setDriverCancel(true);
    closePayHandle(false);
    handleClosepop(false);
    setride(false);
    setCancelStatus(false);
    setShowPopup(false);
    window.location.reload();
  };

  const handleClosepop = () => {
    setcancelPopup(false);
    // setReason("");
  };

  // console.log(driver_Id);

  const otpValue = sessionStorage.getItem("veri-otp");
  const driverName = sessionStorage.getItem("DriverName");
  const driverContact = sessionStorage.getItem("DriverContact");
  const ridestart = sessionStorage.getItem("ride");

  

  const getTripHistory = async () => {
    const data = {
      is_request: "0",
      offset: "0",
      limit: "10",
       statuses:
        "request,completed,paid_cancel,begin,assign,arrive,accept,request,paid,cancel,p_cancel_drop,p_cancel_pickup,expired,assigned",
    };

    if (api_key && userid) {
      try {
        const response = await ApiService.post(
          `${GET_TRIPS}?api_key=${api_key}&user_id=${userid}`,
          data
        );

        if (response.status === 200) {
          const tripResponse = response.data.resDecrypt.response;
          setbookingtable(tripResponse);

          const currentTripId = tripResponse[0]?.trip_id;
          const currentTripStatus = tripResponse[0]?.trip_status;

          // Check if the toast for this trip has already been shown
          const shownTrips =
            JSON.parse(localStorage.getItem("shownTrips")) || [];

          if (tid === currentTripId && !shownTrips.includes(currentTripId)) {
            if (currentTripStatus === "accept") {
              toast.success("Your ride has been accepted.");
            }

            if (currentTripStatus === "arrive") {
              toast.success("Driver has arrived.");
            }

            // Add the tripid to the list of shown trips to prevent duplicate toasts
            shownTrips.push(currentTripId);
            localStorage.setItem("shownTrips", JSON.stringify(shownTrips));
          }
        }
        if (response.status === 401) {
          localStorage.clear();
          sessionStorage.clear();
          navigate("/login");
          window.location.reload(); // This will reload the page after navigation
        }
      } catch (error) {
        if ("Request failed with status code 401" == error.message) {
          sessionStorage.clear();
          localStorage.clear();
          window.location.href = "/login";
        }
        console.log("Error::", error);
      }
    }
  };

  const PaidWitCash = async (res) => {
    const data = {
      trip_pay_status: "Initiated",
      trip_id: res.trip_id,
      trip_pay_mode: "Cash",
      is_use_wallet: "0",
    };
    try {
      const response = await ApiService.post(
        `/tripapi/updatetrip?api_key=${api_key}`,
        data
      );
      if (response.status === 200) {
        setride(false);

        // setThank(true);
        // console.log(response.data.response)

        let Param =
          res.Driver.d_device_type === "Android"
            ? {
                trip_id: res.trip_id,
                trip_status: "Initiated",
                android: res.Driver.d_device_token,
                message: "Rider is paying cash",
              }
            : {
                trip_id: res.trip_id,
                trip_status: "Initiated",
                ios: res.Driver.d_device_token,
                message: "Rider is paying cash",
              };

        const params = new URLSearchParams({
          api_key: api_key,
          ...Param, // Assumes `Params` is an object with key-value pairs
        });

        try {
          const response = await fetch(
            `https://hmapis.appicial.com/api/v1/push2/driver-android-ios-push-notification?${params.toString()}`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          if (!response.ok) {
            throw new Error("Network response was not ok");
          }

          const result = await response.json();

          toast.success(
            "Please wait for confirmation, as your request has been initiated."
          );

          // window.location.reload();
        } catch (error) {
          console.log("Error::", error);
          toast.error(
            "Please select a different payment method, as we are currently unable to proceed with this one."
          );
        }
      }
    } catch (error) {
      console.log("Error::", error);
    }
  };


  let csvData = bookingtable?.map((it, ind) => {
    var e = new Date(it.trip_date);
    var utc_offset_gmt = e.getTimezoneOffset();
    e.setMinutes(e.getMinutes() - utc_offset_gmt);
    it.date = moment(e).format("YYYY-MM-DD");
    it.timefor = moment(e).format("hh:mm a");


    it.status = statusValues[it.trip_status];
    return it;
  });

  const [toastShown, setToastShown] = useState(false);

  useEffect(() => {
    csvData?.forEach((item) => {
      if (
        item.trip_id == storage_trip_id &&
        (item.trip_status === "paid_cancel" ||
          item.trip_status === "cancel" ||
          item.trip_status === "p_cancel_pickup" ||
          item.trip_status === "p_cancel_drop") &&
          storage_trip_id &&
        !toastShown // Check if toast has already been shown
      ) {
        setDriverCancel(false);
        if (!tripcancel) {
          sessionStorage.removeItem("ride");
          localStorage.removeItem("storagetripid");
          localStorage.removeItem("tripid");

        }
        if (trip_pay_mode == "Card") {
          sessionStorage.removeItem("ride");
          sessionStorage.removeItem("pm");
          localStorage.removeItem("storagetripid");
          localStorage.removeItem("tripid");

        }

        toast.dismiss()
        toast.error("Your ride has been canceled.");
        window.location.reload()
        setToastShown(true); // Set toastShown to true after showing the toast
      }
    });
  }, [csvData, toastShown, trip_Id, tid,storage_trip_id, tripcancel]);

  useEffect(() => {
    csvData?.forEach((item) => {
      if (
        item.trip_id === trip_Id &&
        item.trip_status === "completed" &&
        !thank &&
        tid &&
        !toastShown
      ) {
        setDriverCancel(false);
        sessionStorage.removeItem("ride");
        localStorage.removeItem("tripid");
        setThank(true);
        setToastShown(true);
        // Set toastShown to true after showing the toast
      }
    });
  }, [csvData, trip_Id, tid, tripcancel]);

  //Paid With Wallet

  const wamt = sessionStorage.getItem("wmt");

  
  const getUserData = async () => {
    try {
      const response = await ApiService.post(`${GET_USER}?api_key=${api_key}`, {
        user_id: userid,
      });
      if (response.status === 200) {
        const value = response.data.resDecrypt.response;
        sessionStorage.setItem("wmt", value[0]?.u_wallet ? value[0]?.u_wallet : "0");
        return value[0]?.u_wallet ? value[0]?.u_wallet : "0"
      }
    } catch (error) {
      console.log("User fetch ErrorError::", error);
    }
  };

  const payWithWallet = async (trip) => {

    const wamtt = await  getUserData()

    sessionStorage.setItem("tripaccept", JSON.stringify(csvData[0]));

    if (Number(wamtt) < Number(trip.trip_pay_amount)) {
      toast.error("Insufficient wallet amount");
    } else {
      try {
        let data = {
          trip_id: trip.trip_id,
          driver_id: trip.driver_Id,
          pay_mode: "wallet",
          pay_amount: trip.trip_pay_amount,
          total_amt: trip.trip_pay_amount,
          rider_amt: trip.trip_pay_amount,
          r_curr: "INR",
          curr_multiplier:1,
          promo_amt: trip.trip_promo_amt,
          commission_amt: trip.trip_comp_commision,
          trip_driver_commision: trip.trip_driver_commision,
          trans_description: "Trip Payment",
        };

        const result = await ApiService.post(
          `/tronsactionapi/addtriptrans?api_key=${api_key}&&user_id=${userid}`,
          data
        );

        if (result?.status === 200) {
          const data = {
            trip_id: trip.trip_id,
            trip_status: "completed",
            trip_pay_status: "Paid",
            trip_pay_date: formattedTime,
            trip_pay_mode: "wallet",
          };
          try {
            const response = await ApiService.post(
              `/tripapi/updatetrip?api_key=${api_key}`,
              data
            );
            if (response.status === 200) {
              setride(false);
              setCancelStatus(false);
              setThank(true);
              setCancelStatus(false);
              sessionStorage.removeItem("ride");
              setride(false);
              setcardEndTripPay(false);
              setOffers([]);
              setdecline_trip(false);
              setcancelFee(false);
              setReason("");
              setDriverCancel(true);
              settripcancel(true);
              closePayHandle(false);
              handleClosepop(false);
              setride(false);
              setCancelStatus(false);
              setShowPopup(false);

              toast.success(
                "Please wait for confirmation, as your request has been initiated."
              );
              // console.log(response.data.response)
            }
          } catch (error) {
            console.log("Error::", error);
            closePayHandle(false);
            toast.success(
              "Please try again some time later."
            );

          }
        }
      } catch (error) {
        console.log("Error::", error);
        closePayHandle(false);
        toast.success(
          "Please try again some time later."
        );
      }
    }
  };

  const handlePayAmount = async (id) => {
    closePayHandle(false);
    fetch(
      `${process.env.REACT_APP_API_BASE_URL}/userapi/create_wallet_payment_intent?api_key=${api_key}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          amount: tripData.trip_pay_amount,
          currency: "EUR",
          payment_method_id: id,
          customer_id: sessionStorage.getItem("stripe_cust_id"),
          description: "HireMe booking website",
        }),
      }
    ).then(async (result) => {
      var response = await result.json();
      console.log({ result }, { response });
      if (result.status == 200) {
        let data = {
          rider_amt: tripData.trip_pay_amount,
          trans_desc: "Recharge",
          r_curr: "INR",
          city_id: 14,
          curr_multiplier: 1,
          total_amt: tripData.trip_pay_amount,
          pay_response: id,
        };

        console.log(tripData)

  
     
        handlePayCard(id)
      }
    });
  };

  const handlePayCard = async (id) => {
         try {

          let data = {
            total_amt: tripData?.trip_pay_amount,
            trip_id:tripData?.trip_id,
            driver_id:tripData?.driver_id,
            pay_mode:"Card",
            rider_amt:tripData?.trip_pay_amount,
            pay_amount:tripData?.trip_pay_amount,
            promo_amt: tripData?.trip_promo_amt,
            commission_amt:tripData?.trip_comp_commision,
            trip_driver_commision:tripData?.trip_driver_commision,
            trans_description: "Trip Payment",
            r_curr: "INR",
            curr_multiplier:1

          };
        
          const result = await ApiService.post(
            `/tronsactionapi/addtriptrans?api_key=${api_key}&&user_id=${userid}`,
            data
          );
          if (result?.status === 200) {
              const data = {
              trip_id: tripData?.trip_id,
              trip_status: tripData?.trip_status,
              trip_pay_status: "Paid",
              trip_pay_date: formattedTime,
              trip_pay_mode: "Card",
              pay_response: id,

            };
        
            try {
              const response = await ApiService.post(
                `/tripapi/updatetrip?api_key=${api_key}`,
                 data
              );
              if (response.status === 200) {
                setride(false);
                setCancelStatus(false);
                setThank(true);
                setCancelStatus(false);
                sessionStorage.removeItem("ride");
                setride(false);
                setcardEndTripPay(false);
                setOffers([]);
                setdecline_trip(false);
                setcancelFee(false);
                setReason("");
                setDriverCancel(true);
                settripcancel(true);
                closePayHandle(false);
                handleClosepop(false);
                setride(false);
                setCancelStatus(false);
                setShowPopup(false);
                handleCloseCard()
                toast.success(
                  "Please wait for confirmation, as your request has been initiated."
                );
              }
            } catch (error) {
              console.log("Error::", error);
              closePayHandle(false);
              handleCloseCard()
              toast.success(
                "Please try again some time later."
              );
            }
        
          }
        } catch (error) {
           console.log("Error::", error);
           closePayHandle(false);
           handleCloseCard()
           toast.success(
             "Please try again some time later."
           );
        }
 
  };

  const declinewithcard = async () => {
    sessionStorage.setItem("tripaccept", JSON.stringify(csvData[0]));

    const data = {
      trip_id: JSON.parse(tripaccept).trip_id,
      trip_pay_status: "Paid",
      trip_pay_date: formattedTime,
      trip_pay_mode: "Card",
    };
    try {
      const response = await ApiService.post(
        `/tripapi/updatetrip?api_key=${api_key}`,
        data
      );
      if (response.status === 200) {
        setride(false);
        setCancelStatus(false);
        sessionStorage.removeItem("ride");
        setride(false);
        setcardEndTripPay(false);
        setOffers([]);
        setdecline_trip(false);
        setcancelFee(false);
        setReason("");
        setDriverCancel(true);
        settripcancel(true);
        closePayHandle(false);
        handleClosepop(false);
        setride(false);
        setCancelStatus(false);
        setShowPopup(false);
        // setThank(true);

        // console.log(response.data.response)
      }
    } catch (error) {
      console.log("Error::", error);
    }
  };

  const payWithWalletCancel = async (res) => {
    const wamtt = await  getUserData()

    if (Number(wamtt) < Number(res.trip_pay_amount)) {
      // console.log(wamt, JSON.parse(tripaccept).trip_pay_amount);
      toast.error("Insufficient wallet amount");
    } else {
      try {
        let data = {
          trip_id: res.trip_id,
          driver_id: res.driver_id,
          pay_mode: "wallet",
          pay_amount: res.trip_pay_amount,
          total_amt: res.trip_pay_amount,
          rider_amt: res.trip_pay_amount,
          promo_amt: res.trip_promo_amt,
          commission_amt: res.trip_comp_commision,
          trip_driver_commision: res.trip_driver_commision,
          r_curr: "INR",
          curr_multiplier:1,
          trans_description: "Trip Payment",
        };

        const result = await ApiService.post(
          `/tronsactionapi/addtriptrans?api_key=${api_key}&&user_id=${userid}`,
          data
        );

        if (result?.status === 200) {
          sessionStorage.removeItem("ride");
          setride(false);
          setcardEndTripPay(false);
          setOffers([]);
          setdecline_trip(false);
          setcancelFee(false);
          setReason("");
          setDriverCancel(true);
          settripcancel(true);
          closePayHandle(false);
          handleClosepop(false);
          setCancelStatus(false);
          setShowPopup(false);

          const data = {
            trip_id: res.trip_id,
            trip_pay_status: "Paid",
            trip_pay_date: formattedTime,
            trip_pay_mode: "wallet",
          };
          try {
            const response = await ApiService.post(
              `/tripapi/updatetrip?api_key=${api_key}`,
              data
            );
            if (response.status === 200) {
              setride(false);
              setCancelStatus(false);
              setThank(true);
              toast.success(
                "Please wait for confirmation, as your request has been initiated."
              );
              closePayHandle(false);

              // console.log(response.data.response)
            }
          } catch (error) {
            console.log("Error::", error);
            closePayHandle(false);
            toast.success(
              "Please try again some time later."
            );
          }
        }
      } catch (error) {
        console.log("Error::", error);
        closePayHandle(false);
        toast.success(
          "Please try again some time later."
        );
      }
    }
  };

  const closePayHandle = () => {
    setCardPay(false);
  };

  // send Feedback
  const sendFeedback = async (trip) => {
                             

    const data = {
      trip_id: trip.trip_id,
      trip_feedback: feedback,
      api_key: api_key,
      trip_rating: rating,
    };
    
    let totalRating = 0;
    
    // Check if d_rating and d_rating_count are defined and calculate the new rating
    if (trip.Driver?.d_rating !== undefined && trip.Driver?.d_rating_count !== undefined) {
      totalRating = (
        (parseFloat(trip.Driver.d_rating) * parseFloat(trip.Driver.d_rating_count) + parseFloat(rating)) /
        (parseFloat(trip.Driver.d_rating_count) + 1.0)
      );
    } else {
      // Fallback in case d_rating or d_rating_count is not defined
      totalRating = rating;
    }
    
    const Driverdata = {
      driver_id: trip.Driver?.driver_id,
      api_key: api_key,
      d_rating: totalRating,
      d_rating_count: parseFloat(trip.Driver?.d_rating_count || 0) + 1.0,
    };
    

    
   try {
    const response = await ApiService.post(
      `/driverapi/updatedriverprofile?api_key=${api_key}`,
      Driverdata
    );
    if (response.status === 200) {
      setride(false);
      setfeebackState(false);
      // console.log(response.data.response)
    }
  } catch (error) {
    console.log("Error::", error);
  }
    
    try {
      const response = await ApiService.post(
        `/tripapi/updatetrip?api_key=${api_key}`,
        data
      );
      if (response.status === 200) {
        setride(false);
        setfeebackState(false);
        // console.log(response.data.response)
      }
    } catch (error) {
      console.log("Error::", error);
    }
  };


  const [tripDone, setTripDone] = useState(false);

  // console.log(tid)

  const handleTripComplete = () => {
    if (tid == csvData[0]?.id) {
      if (
        csvData[0]?.trip_status == "completed" ||
        csvData[0]?.trip_status == "cancel"
      ) {
        setTripDone(false);
        sessionStorage.removeItem("ride");
        setride(false);
      }
    }

    csvData?.forEach((item) => {
      if (item) {
        if (item?.trip_id == JSON.parse(tripaccept)?.trip_id) {
          // console.log(item.trip_id == JSON.parse(tripaccept).trip_id, item.trip_id, JSON.parse(tripaccept).trip_id)

          setTripDone(false);
          sessionStorage.removeItem("ride");
          setride(false);
          localStorage.removeItem("tripid");
        }
      }
    });
  };

  const handleClosefees = () => {
    setcancelFee(false);
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      handleTripComplete();
    }, 2000); // 20 seconds in milliseconds
    // Cleanup function to clear the interval when the component is unmounted
    return () => clearInterval(intervalId);
  }, []);


  return (
    <div>

    {card && (
      <div className="popup-overlay" style={{ paddingBottom: "50px" }}>
        <div className="popup-content">
          <div
            style={{
              float: "right",
            }}
          >
            <button
              style={{
                background: "black",
                color: "white",
                borderRadius: "50%",
                padding: "12px 18px",
              }}
              onClick={handleCloseCard}
            >
              X
            </button>
          </div>
          <h2 className="popup-title">Payment</h2>
          <PaymentComponent
            handleCloseCard={handleCloseCard}
            apiHandler={handlePayAmount}
          />
        </div>
      </div>
    )}

    {
      csvData.some(
        (data) =>
          data.trip_status === "accept" ||
          data.trip_status === "begin" ||
          data.trip_status === "arrive"
      ) && (
        <>
          <div className="backdrop">
            <div className="center-screen" style={{ position: "fixed" }}>
              <div className="offercount">
                {csvData
                  .filter(
                    (data) =>
                      data.trip_status === "accept" ||
                      data.trip_status === "begin" ||
                      data.trip_status === "arrive"
                  )
                  .map((data, index) => (
                    <div key={index} style={{ display: "grid", width: 300, marginBottom: "20px" }}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginBottom: "4px",
                          justifyContent: "center",
                        }}
                      >
                        {data.trip_status === "accept"
                          ? "Driver Assigned"
                          : data.trip_status === "arrive"
                          ? "Driver Arrived"
                          : "Begin"}
                      </div>
                      <hr style={{ width: "100%" }} />
                      <div>
                        {expiryTimestamp ? (
                          <MyTimer expiryTimestamp={expiryTimestamp} />
                        ) : (
                          ""
                        )}
                      </div>
                      {data.trip_status !== "begin" && (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginBottom: "20px",
                          }}
                        >
                          <div>OTP:</div>
                          <div
                            style={{
                              fontSize: "18px",
                              fontWeight: "500",
                              marginLeft: "5px",
                            }}
                          >
                            {data.otp}
                          </div>
                        </div>
                      )}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginBottom: "4px",
                          justifyContent: "center",
                        }}
                      >
                        <img
                          src={`https://hmimages.appicial.com/originals/${
                            data.Driver?.d_profile_image_path || "default-image.png"
                          }`}
                          alt="Driver Profile"
                          width={100}
                          height={100}
                          style={{ borderRadius: "50%" }}
                        />
                        <div style={{position:"relative",bottom:"-31px",right:"31px"}}>
                        <div
                          style={{
                            width: "40px",
                            height: "25px",
                            display: "flex",
                            fontSize: "12px",
                            justifyContent: "space-between",
                            alignItems: "center",
                            color: "#fff",
                            borderRadius: "10%",
                            backgroundColor: getStarBackgroundColor(data.Driver?.d_rating),
                          }}
                        >
                          &nbsp;{Number(data.Driver?.d_rating)?.toFixed(1)}
                          &nbsp;
                          <span
                            style={{
                              color: "#fff",
                              fontSize: "18px",
                            }}
                          >
                            ★
                          </span>
                          </div>
                          </div>
                      </div>
                      <table
                        style={{
                          marginTop: 20,
                          marginBottom: 20,
                          width: "100%",
                          height: "150px",
                          margin: "0 auto",
                          textAlign: "left",
                        }}
                      >
                        <tbody>
                          <tr>
                            <td style={{ paddingRight: "10px", fontWeight: "bold" }}>
                              Driver Name:
                            </td>
                            <td
                              style={{
                                fontSize: "18px",
                                fontWeight: "500",
                              }}
                            >
                              {data.Driver?.d_name}
                            </td>
                          </tr>
                          <tr>
                            <td style={{ paddingRight: "10px", fontWeight: "bold" }}>
                              Driver Contact:
                            </td>
                            <td
                              style={{
                                fontSize: "18px",
                                fontWeight: "500",
                              }}
                            >
                              {data.Driver?.d_phone}
                            </td>
                          </tr>
                          <tr>
                            <td style={{ paddingRight: "10px", fontWeight: "bold" }}>
                              Car Name:
                            </td>
                            <td
                              style={{
                                fontSize: "18px",
                                fontWeight: "500",
                              }}
                            >
                              {data.Driver?.car_name}
                            </td>
                          </tr>
                          <tr>
                            <td style={{ paddingRight: "10px", fontWeight: "bold" }}>
                              Car Reg No:
                            </td>
                            <td
                              style={{
                                fontSize: "18px",
                                fontWeight: "500",
                              }}
                            >
                              {data.Driver?.car_reg_no}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      {data.trip_status !== "begin" && (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            marginTop: "25px",
                          }}
                        >
                          <button
                            style={{
                              background: "black",
                              color: "white",
                              padding: "5px 10px 5px 10px",
                            }}
                            onClick={handleCancelClick}
                          >
                            Cancel Ride
                          </button>
                        </div>
                      )}
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </>
      )
    }
    
    

      {cancelPopup && (
        <>
          <div className="backdrop">
            <div className="center-screen ">
              <div
                className="popup"
                style={{ boxShadow: "0px 0px 0px 1px black" }}
              >
                <div className="container-wrapper">
                  <div className="popup-inner">
                    <div className="tripcancle" style={{ marginTop: "20px" }}>
                      Reason:{" "}
                      <input
                        className="Noteinput"
                        value={reason}
                        onChange={(e) => setReason(e.target.value)}
                        style={{ marginLeft: "5px", width: "60%" }}
                      />
                    </div>
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <button
                        style={{
                          background: "black",
                          color: "white",
                          padding: "5px 10px 5px 10px",
                          marginRight: "10px",
                        }}
                        onClick={declineNotificationApi}
                      >
                        Submit
                      </button>
                      <button
                        style={{
                          background: "grey",
                          color: "white",
                          padding: "5px 10px 5px 10px",
                        }}
                        onClick={handleClosepop}
                      >
                        Close
                      </button>
                    </div>
                  </div>{" "}
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {thank && (
        <>
          {" "}
          <div className="backdrop" >
          <div className="center-screen " style={{ position: "fixed" }}>
            <div className="offercount">
              <div
                style={{
                  marginBottom: "20px",
                  padding: "25px",
                }}
              >
                Thank You For using HireMe!
              </div>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <button
                  style={{
                    background: "black",
                    color: "white",
                  }}
                  onClick={handleClose}
                >
                  Close
                </button>
              </div>
            </div>          </div>

          </div>
        </>
      )}
      {cardPay && (
        <div className="popup-overlay" style={{ paddingBottom: "50px" }}>
          <div className="popup-content">
            <div
              style={{
                float: "right",
              }}
            >
              <button
                style={{
                  background: "black",
                  color: "white",
                  padding: "5px 20px",
                }}
                onClick={closePayHandle}
              >
                X
              </button>
            </div>
            <h2 className="popup-title">Payment</h2>
            <PaymentComponent
              setride={setride}
              setThank={setThank}
              date={csvData[0]?.trip_date}
              payAmount={payAmount}
              setDriverCancel={setDriverCancel}
              closePayHandle={closePayHandle}
              offers={offers}
              startTimer={startTimer}
              city_cur={cityInfo.pg_cur}
            />
          </div>
        </div>
      )}

      {cardEndTripPay && (
        <div
          className="popup-overlay"
          style={{ zIndex: 99999, padding: "50px" }}
        >
          <div className="popup-content">
            <div
              style={{
                float: "right",
              }}
            >
              <button
                style={{
                  background: "black",
                  color: "white",
                  padding: "5px 20px",
                }}
                onClick={handlePayCardOptionClose}
              >
                X
              </button>
            </div>
            <h2 className="popup-title">Payment</h2>
            <PaymentCardComponent
              trip_Id={trip_Id}
              setride={setride}
              setThank={setThank}
              date={csvData[0]?.trip_date}
              amount={payAmount}
              setDriverCancel={setDriverCancel}
              closePayHandle={handlePayCardOptionClose}
              offers={offers}
              cancelStatus={cancelStatus}
              declineNotificationApi={declinewithcard}
              setCancelStatus={setCancelStatus}
              city_cur={cityInfo.pg_cur}
            />
          </div>
        </div>
      )}

      {/*    {cancelFee && trip_pay_mode !== "Card" && (
        <div className="popup-container">
          <div
            className="popup4"
            style={{ boxShadow: "0px 0px 0px 1px black" }}
          >
            <select
              style={{
                width: "190px",
                padding: "3px",
                border: "1px solid #eee",
              }}
              onChange={(e) => {
                const selectedValue = e.target.value;
                if (selectedValue === "cash") {
                  PaidWitCash();
                } else if (selectedValue === "card") {
                  handlePayCardOption();
                  handleClosefees();
                } else if (selectedValue === "wallet") {
                  payWithWallet();
                  handleClosefees();
                }
              }}
            >
              <option selected disabled>
                Select Payment Method
              </option>
              {city_id == cityInfo.city_id && (
                <option value="wallet">Wallet</option>
              )}
              <option value="card">Card</option>
            </select>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <button
                style={{
                  background: "black",
                  color: "white",
                  padding: "5px 10px 5px 10px",
                }}
                onClick={handleClosefees}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
 */}

      {/*       {csvData &&
        csvData?.length > 0 &&
        csvData[0]?.trip_pay_status !== "Paid" &&
        csvData[0]?.trip_pay_mode !== "Card" &&
        csvData[0]?.trip_pay_amount !== "0" && (
          <>
            <div className="popups-container">
              <div className="backdrop" />

              {csvData[0]?.trip_status === "cancel" ||
              csvData[0]?.trip_status === "paid_cancel" ||
              csvData[0]?.trip_status == "completed" ? (
                <React.Fragment key={csvData[0].trip_id}>
                  <div
                    className="center-screen"
                    style={{ position: "absolute", minHeight: "365px" }}
                  >
                    <div className="offercount">
                      <div style={{ display: "grid" }}>
                        <div style={{ display: "grid", position: "relative" }}>
                          <div className="dot red-dot" />
                          <div style={{ marginLeft: "20px" }}>
                            Pickup Location:
                            <div className="loc" style={{ display: "grid" }}>
                              {csvData[0].trip_from_loc}
                            </div>
                          </div>
                          <div className="vertical-line"></div>
                          <div className="dot green-dot" />
                          <div style={{ marginLeft: "20px" }}>
                            Drop Location:
                            <div className="loc">{csvData[0].trip_to_loc}</div>
                          </div>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            marginTop: "20px",
                            marginBottom: "20px",
                          }}
                        >
                          Status:
                          <span
                            style={{ fontWeight: "700", marginLeft: "5px" }}
                          >
                            {csvData[0].trip_pay_status
                              ? csvData[0].trip_pay_status
                              : "Unpaid"}
                          </span>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            marginBottom: "20px",
                          }}
                        >
                          Pay Amount:
                          <span
                            style={{ fontWeight: "700", marginLeft: "5px" }}
                          >
                            {cityInfo.city_cur} {csvData[0].trip_pay_amount}
                          </span>
                        </div>

                        {feebackState ? (
                          <>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                marginBottom: "20px",
                              }}
                            >
                              <ReactStars
                                count={5}
                                edit={true}
                                value={rating}
                                isHalf={true}
                                a11y={true}
                                activeColor="#ffd700"
                                onChange={ratingChanged}
                                size={25}
                                color2={"#ffd700"}
                              />
                            </div>
                            <div
                              className="feedback"
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                marginBottom: "20px",
                              }}
                            >
                              Feedback:
                              <input
                                type="text"
                                onChange={handleInputChange}
                                className="Noteinput"
                                style={{ marginLeft: "5px" }}
                              />
                            </div>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                marginBottom: "20px",
                              }}
                            >
                              <button
                                style={{
                                  background: "black",
                                  color: "white",
                                  padding: "5px 20px",
                                }}
                                onClick={() =>
                                  sendFeedback(
                                    csvData[0].Driver.api_key,
                                    csvData[0].trip_id
                                  )
                                }
                              >
                                Submit Feedback
                              </button>
                            </div>
                          </>
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              marginBottom: "20px",
                            }}
                          >
                            Thank You For Your Valuable Feedback
                          </div>
                        )}

                        {csvData &&
                        csvData[0]?.trip_pay_status?.toLowerCase() !== "paid" &&
                        csvData[0]?.trip_pay_amount !== "0" ? (
                          <>
                            <div className="popup-container">
                              {showPopup && trip_pay_mode !== "Card" && (
                                <div
                                  className="popup"
                                  style={{
                                    boxShadow: "0px 0px 0px 1px black",
                                    display: "grid",
                                  }}
                                >
                                  <select
                                    style={{
                                      width: "190px",
                                      padding: "3px",
                                      border: "1px solid black",
                                    }}
                                    onChange={(e) => {
                                      const selectedValue = e.target.value;
                                      if (selectedValue === "cash") {
                                        PaidWitCash();
                                      } else if (selectedValue === "card") {
                                        handlePayCardOption(csvData[0].trip_id);
                                      } else if (selectedValue === "wallet") {
                                        csvData[0]?.trip_status === "completed"
                                          ? payWithWallet(csvData[0].trip_id)
                                          : payWithWalletCancel(
                                              csvData[0].trip_id
                                            );
                                      }
                                    }}
                                  >
                                    <option selected disabled>
                                      Select Payment Method
                                    </option>
                                    {city_id === cityInfo.city_id && (
                                      <option value="wallet">Wallet</option>
                                    )}
                                    <option value="card">Card</option>
                                  </select>
                                  <button
                                    onClick={handlePayClick}
                                    style={{
                                      background: "black",
                                      color: "white",
                                      padding: "5px 20px",
                                    }}
                                  >
                                    Close
                                  </button>
                                </div>
                              )}
                            </div>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <button
                                onClick={
                                  trip_pay_mode !== "Card"
                                    ? handlePayClick
                                    : handleCloseTripDetail
                                }
                                style={{
                                  background: "black",
                                  color: "white",
                                  padding: "5px 20px",
                                }}
                              >
                                {trip_pay_mode !== "Card" ? "Pay" : "Close"}
                              </button>
                            </div>
                          </>
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <button
                              onClick={handleCloseTripDetail}
                              style={{
                                background: "black",
                                color: "white",
                                padding: "5px 20px",
                              }}
                            >
                              Close
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              ) : (
                ""
              )}
            </div>
          </>
        )} */}


      {csvData &&
  csvData.length > 0 &&
  csvData
    ?.filter(
      (trip) =>
        trip.Driver !== null &&
        trip.trip_pay_status !== "Paid" &&
        trip.trip_pay_mode !== "Card" &&
         trip.trip_pay_amount !== "0" &&
        (trip.trip_status === "cancel" || trip.trip_status === "completed")
    )
    .map((trip, index) => (
       <React.Fragment key={trip.trip_id}>
                <div className="popups-container">
                  <div className="backdrop" >
                  <div
                    className="center-screen"
                    style={{ position: "absolute", minHeight: "365px" }}
                  >
                    <div className="offercount">
                      <div style={{ display: "grid" }}>
                        <div style={{ display: "grid", position: "relative" }}>
                          <div className="dot red-dot" />
                          <div style={{ marginLeft: "20px" }}>
                            Pickup Location:
                            <div className="loc" style={{ display: "grid" }}>
                              {trip.trip_from_loc}
                            </div>
                          </div>
                          <div className="vertical-line"></div>
                          <div className="dot green-dot" />
                          <div style={{ marginLeft: "20px" }}>
                            Drop Location:
                            <div className="loc">{trip.trip_to_loc}</div>
                          </div>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            marginTop: "20px",
                            marginBottom: "20px",
                          }}
                        >
                          Status:
                          <span
                            style={{ fontWeight: "700", marginLeft: "5px" }}
                          >
                            {trip.trip_pay_status
                              ? trip.trip_pay_status
                              : "Unpaid"}
                          </span>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            marginBottom: "20px",
                          }}
                        >
                          Pay Amount:
                  <span
                  translate="no" 
                            style={{ fontWeight: "700", marginLeft: "5px" }}
                          >
                            {cityInfo?.city_cur} {trip?.trip_pay_amount}
                          </span>
                        </div>

                        {feebackState ? (
                          <>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                marginBottom: "20px",
                              }}
                    >
                      <span            translate="no" 
                      >
                    
                        
                        <ReactStars
                        count={5}
                        edit={true}
                        value={rating}
                        isHalf={true}
                        a11y={true}
                        activeColor="#ffd700"
                        onChange={ratingChanged}
                        size={25}
                        color2={"#ffd700"}
     
                      />
                      </span>
                    
                            </div>
                            <div
                              className="feedback"
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                marginBottom: "20px",
                              }}
                            >
                              Feedback:
                              <input
                                type="text"
                                onChange={handleInputChange}
                                className="Noteinput"
                                style={{ marginLeft: "5px" }}
                              />
                            </div>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                marginBottom: "20px",
                              }}
                            >
                              <button
                                style={{
                                  background: "black",
                                  color: "white",
                                  padding: "5px 20px",
                                }}
                                onClick={() =>
                                  sendFeedback(
                                    trip
                                  )
                                }
                              >
                                Submit Feedback
                              </button>
                            </div>
                          </>
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              marginBottom: "20px",
                            }}
                          >
                            Thank You For Your Valuable Feedback
                          </div>
                        )}

                        {trip &&
                        trip?.trip_pay_status?.toLowerCase() !== "paid" &&
                        trip?.trip_pay_amount !== "0" ? (
                          <>
                            <div className="popup-container">
                          {showPopup && trip_pay_mode !== "Card" && (
                            <div className="backdrop">
                                <div
                                  className="popup"
                                  style={{
                                    boxShadow: "0px 0px 0px 1px black",
                                    display: "flex",
                                    flexDirection: "column",
                                    gap:"20px",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    background:"white",
                                    padding: "20px",
                                    borderRadius:"6px"

                                  }}
                                >
                                  <select
                                    style={{
                                      width: "190px",
                                      padding: "3px",
                                      border: "1px solid black",
                                    }}
                                    onChange={(e) => {
                                      const selectedValue = e.target.value;
                                      if (selectedValue === "Cash") {
                                        PaidWitCash(trip);
                                      } else if (selectedValue === "Card") {
                                        handlePayCardOption(trip);
                                      } else if (selectedValue === "Wallet") {
                                        trip?.trip_status === "completed"
                                          ? payWithWallet(trip)
                                          : payWithWalletCancel(
                                              trip
                                            );
                                      }
                                    }}
                                  >
                                    <option selected disabled>
                                      Select Payment Method
                                    </option>
                                    {city_pay_options
                                     ?.filter((data) => data.name !== "Caash")
                                     .map((data) => (
                                     <option value={data.name} key={data.id}>
                                     {data.name}
                                      </option>
                                       ))}

                                  </select>
                                  <button
                                       onClick={
                                   () => { handlePayClick(trip) }
                                    }                                    style={{
                                      background: "black",
                                      color: "white",
                                      padding: "5px 20px",
                                      width: "100px",
                                      height:"35px"
                                    }}
                                  >
                                    Close
                                  </button>
                              </div>
                            </div>
                              )}
                            </div>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <button
                                onClick={
                            () => { handlePayClick(trip) }
                                 }
                                style={{
                                  background: "black",
                                  color: "white",
                                  padding: "5px 20px",
                                }}
                              >
                                {trip_pay_mode !== "Card" ? "Pay" : "Close"}
                              </button>
                            </div>
                          </>
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <button
                              onClick={handleCloseTripDetail}
                              style={{
                                background: "black",
                                color: "white",
                                padding: "5px 20px",
                              }}
                            >
                              Close
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
            </div>
            </div>
                </div>
              </React.Fragment>
    ))}

      {tripcancel && (
        <>
          {" "}
          {csvData &&
            csvData?.map((item) =>
              (item.trip_status === "cancel" ||
                item.trip_status === "paid_cancel" ||
                item.trip_status === "complete") &&
              (item.trip_pay_mode == "Card" || item.trip_pay_amount == "0") &&
              tid == item.trip_id ? (
                <React.Fragment key={item.trip_id}>
                  <div className="backdrop" />

                  <div
                    className="center-screen"
                    style={{ position: "absolute" }}
                  >
                    <div className="offercount">
                      <div style={{ display: "grid" }}>
                        <div style={{ display: "grid", position: "relative" }}>
                          <div className="dot red-dot" />
                          <div style={{ marginLeft: "20px" }}>
                            Pickup Location:
                            <div className="loc" style={{ display: "grid" }}>
                              {item.trip_from_loc}
                            </div>
                          </div>
                          <div className="vertical-line"></div>
                          <div className="dot green-dot" />
                          <div style={{ marginLeft: "20px" }}>
                            Drop Location:
                            <div className="loc">{item.trip_to_loc}</div>
                          </div>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            marginTop: "20px",
                            marginBottom: "20px",
                          }}
                        >
                          Status:
                          <span
                            style={{ fontWeight: "700", marginLeft: "5px" }}
                          >
                            {item.trip_pay_status
                              ? item.trip_pay_status
                              : "Unpaid"}
                          </span>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            marginBottom: "20px",
                          }}
                        >
                          Pay Amount:
                          <span
                            style={{ fontWeight: "700", marginLeft: "5px" }}
                          >
                            {cityInfo.city_cur} {item.trip_pay_amount}
                          </span>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <button
                            onClick={handleCloseTripDetail}
                            style={{
                              background: "black",
                              color: "white",
                              padding: "5px 20px",
                            }}
                          >
                            Close
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              ) : (
                ""
              )
            )}
        </>
      )}
      
            {csvData &&
        csvData.map((item) => {
          const isCompleted = item.trip_status === "completed";
          const isPayStatusMatch = item.trip_pay_status === "Paid"; // Replace 'expected_status' with the correct value.
          const isTripIdMatch = Number(storage_trip_id) === Number(item.trip_id);
      
          if (isCompleted && isPayStatusMatch && isTripIdMatch) {
            return (
              <React.Fragment key={item.trip_id}>
                <div className="backdrop" >
      
                <div className="center-screen" style={{ position: "fixed" }}>
                  <div className="offercount">
                    <div style={{ display: "grid" }}>
                      <div style={{ display: "grid", position: "relative" }}>
                        <div className="dot red-dot" />
                        <div style={{ marginLeft: "20px" }}>
                          Pickup Location:
                          <div className="loc" style={{ display: "grid" }}>
                            {item.trip_from_loc}
                          </div>
                        </div>
                        <div className="vertical-line"></div>
                        <div className="dot green-dot" />
                        <div style={{ marginLeft: "20px" }}>
                          Drop Location:
                          <div className="loc">{item.trip_to_loc}</div>
                        </div>
                      </div>
      
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          marginTop: "20px",
                          marginBottom: "20px",
                        }}
                      >
                        Status:
                        <span style={{ fontWeight: "700", marginLeft: "5px" }}>
                          {item.trip_pay_status || "Unpaid"}
                        </span>
                      </div>
      
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          marginBottom: "20px",
                        }}
                      >
                        Pay Amount:
                        <span translate="no"  style={{ fontWeight: "700", marginLeft: "5px" }}>
                          {cityInfo?.city_cur} {item.trip_pay_amount}
                        </span>
                      </div>
                      {feebackState ? (
                        <>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              marginBottom: "20px",
                            }}
                          >
                            <span
                              translate="no" 
                          >
                        
                            
                            <ReactStars
                            count={5}
                            edit={true}
                            value={rating}
                            isHalf={true}
                            a11y={true}
                            activeColor="#ffd700"
                            onChange={ratingChanged}
                            size={25}
                            color2={"#ffd700"}/>
         
                          </span>
                          </div>
                          <div
                            className="feedback"
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              marginBottom: "20px",
                            }}
                          >
                            Feedback:
                            <input
                              type="text"
                              onChange={handleInputChange}
                              className="Noteinput"
                              style={{ marginLeft: "5px" }}
                            />
                          </div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              marginBottom: "20px",
                            }}
                          >
                            <button
                              style={{
                                background: "black",
                                color: "white",
                                padding: "5px 20px",
                              }}
                              onClick={() =>
                                sendFeedback(
                                  item
                                )
                              }
                            >
                              Submit Feedback
                            </button>
                          </div>
                        </>
                      ) : (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            marginBottom: "20px",
                          }}
                        >
                          Thank You For Your Valuable Feedback
                        </div>
                      )}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <button
                          onClick={handleCloseTripDetail}
                          style={{
                            background: "black",
                            color: "white",
                            padding: "5px 20px",
                          }}
                        >
                          Close
                        </button>
                      </div>
                    </div>
                  </div>
                  </div>
                  </div>
              </React.Fragment>
            );
          }
          return null;
        })}
    </div>
  );
};

export default TripProcessPage;
